import { Routes } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { V2RedirectComponent } from './components/v2-redirect/v2-redirect.component';
import { LogoutComponent } from './components/logout/logout.component';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: '',
    loadChildren: async () =>
      (await import('./modules/marketing/marketing.routes')).marketingRoutes,
  },
  {
    path: 'v2',
    children: [
      {
        path: '**',
        component: V2RedirectComponent,
      },
    ],
  },
  {
    path: 'dashboard',
    loadChildren: async () =>
      (await import('./modules/dashboard/dashboard.routes')).dashboardRoutes,
  },
  {
    path: 'browse',
    loadChildren: async () =>
      (await import('./modules/browse/browses.routes')).browsesRoutes,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'code',
    redirectTo: '/dashboard/subscriptions/add-voucher',
  },
  {
    path: '404',
    component: NotFoundComponent,
    data: { title: '404.head.title' },
  },
  { path: '**', redirectTo: '/404' },
];
